<template>
  <div id="pers-tab2-4" name="hrms32e-tab2-tab4">

    <div class="col-xs-12 col-md-6 pull-left">  
      <div class="col-xs-12  card-ui clearfix border-top-color-skin">
        <div class="sub-topic-box clearfix" @click="toggleSubTopic1">
          <i class="fa fa-user icon-sub-topic" aria-hidden="true"></i>
          <div class="sub-topic">{{ labels['HRMS32EC6']['10'] }}</div>
          <div class="sub-topic-num">{{ labels['HRMS32EC14']['20'] }} {{ 1 }}</div>
        </div>
        <div class="data-box clearfix" v-show="subTopic1">
          <div class="data-row">
            <div class="col-xs-5 data-label">{{ labels['HRMS32EC6']['20'] }}</div>
            <div class="col-xs-7 data-input">
                <hrms-dropdown  v-model="detail.codbank" 
                                :options="dropdowns.codbank[nowLang]" 
                                style="margin-bottom:5px;"/>
            </div>
          </div>      
          <div class="data-row">
            <div class="col-xs-5 data-label">{{ labels['HRMS32EC6']['30'] }}</div>
            <div class="col-xs-7 data-input">
              <input type="text" class="form-control input-text" id="numbank" name="numbank" 
                     v-model="detail.numbank" 
                     maxlength="15"
                     v-validate="'max:15'"
                     data-vv-name="numbank"
                     :has-error="errors.has('numbank')" />
              <div class="text-error" v-show="errors.has('numbank')">{{errors.first('numbank')}}</div>
            </div>
          </div>   
          <div class="data-row">
            <div class="col-xs-5 data-label">{{ labels['HRMS32EC6']['40'] }}</div>
            <div class="col-xs-7 data-input">
              <input type="text" class="form-control input-text" id="amtbank" name="amtbank" 
                     v-model="detail.amtbank" 
                     maxlength="6"
                     v-validate="'decimal:2|max:6'"
                     data-vv-name="amtbank"
                     :has-error="errors.has('amtbank')" />
              <div class="text-error" v-show="errors.has('amtbank')">{{errors.first('amtbank')}}</div>
            </div>
          </div>   
        </div>
      </div>
    </div>

    <div class="col-xs-12 col-md-6 pull-right">  
      <div class="col-xs-12  card-ui clearfix border-top-color-skin">
        <div class="sub-topic-box clearfix" @click="toggleSubTopic2">
          <i class="fa fa-user icon-sub-topic" aria-hidden="true"></i>
          <div class="sub-topic">{{ labels['HRMS32EC6']['50'] }}</div>
          <div class="sub-topic-num">{{ labels['HRMS32EC14']['20'] }} {{ 2 }}</div>
        </div>
        <div class="data-box clearfix" v-show="subTopic2">
          <div class="data-row">
            <div class="col-xs-5 data-label">{{ labels['HRMS32EC6']['50'] }}</div>
            <div class="col-xs-7 data-input">
                <hrms-dropdown  v-model="detail.codbank2" 
                                :options="dropdowns.codbank[nowLang]" 
                                style="margin-bottom:5px;"/>
            </div>
          </div>      
          <div class="data-row">
            <div class="col-xs-5 data-label">{{ labels['HRMS32EC6']['60'] }}</div>
            <div class="col-xs-7 data-input">
              <input type="text" class="form-control input-text" id="numbank2" name="numbank2" 
                     v-model="detail.numbank2" 
                     maxlength="15"
                     v-validate="'max:15'"
                     data-vv-name="numbank2"
                     :has-error="errors.has('numbank2')" />
              <div class="text-error" v-show="errors.has('numbank2')">{{errors.first('numbank2')}}</div>
            </div>
          </div> 
        </div>
      </div>
    </div>
    <div class="col-md-12 box-footer">
      <button type="button" class="btn bg-dark-gray pull-left" @click="togglePage(0)" value="Back"><i class="fa fa-chevron-circle-left"></i>{{ labelsButton['back'] }}</button>
      <button type="button" class="btn bg-color-skin" @click="callSave()" v-if="validateStaappr"><i class="fa fa-check-circle"></i>{{ labelsButton['save'] }}</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'hrms32e-tab2-tab4',
  data () {
    return {
      subTopic1: true,
      subTopic2: true
    }
  },
  watch: {
    'detail.numbank' () {
      this.$validator.validate('numbank', this.detail.numbank).catch(e => {})
    },
    'detail.amtbank' () {
      this.$validator.validate('amtbank', this.detail.amtbank).catch(e => {})
    },
    'detail.numbank2' () {
      this.$validator.validate('numbank2', this.detail.numbank2).catch(e => {})
    },
    detail () {
      this.$nextTick(() => {
        this.errors.clear()
      })
    }
  },
  methods: {
    toggleSubTopic1 () {
      this.subTopic1 = !this.subTopic1
    },
    toggleSubTopic2 () {
      this.subTopic2 = !this.subTopic2
    },
    saveParams () {
      return {
        p_dtereq: this.searchDetail.dtereq,
        p_numseq: this.indexSelected.numseq,
        n_codbank: this.detail.codbank,
        n_numbank: this.detail.numbank,
        n_amtbank: this.detail.amtbank,
        n_codbank2: this.detail.codbank2,
        n_numbank2: this.detail.numbank2,
        p_codempid_query: this.searchDetail.codempid_query
      }
    },
    callSave () {
      this.$validator.validateAll().then(result => {
        if (result && this.searchDetail.codempid_query !== '') {
          this.postDetail2Tab4Save({ saveParams: this.saveParams(), searchIndex: this.searchIndex, togglePage: this.togglePage })
        }
      })
    }
  },
  props: [ 'nowLang', 'labels', 'detail', 'indexSelected', 'pcDisp', 'togglePage', 'toggleSubPage', 'triggerSubButton', 'labelsButton', 'dropdowns', 'postDetail2Tab4Save', 'searchDetail', 'searchIndex', 'validateStaappr' ]
}

</script>


// WEBPACK FOOTER //
// tab2_4.vue?46c6a155